require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-nhs-living-with.json") })
        }
      }, "path---article-nhs-living-with");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-nhs-living-with!./.cache/json/article-nhs-living-with.json
// module id = 364
// module chunks = 231608221292675